const OrderKey = "orderKey";
const CartKey = "cartKey";
const TransactionKey = 'transactionKey';

export function setOrder(data) {
  return localStorage.setItem(OrderKey, JSON.stringify(data));
}
export function setCart(data) {
  return localStorage.setItem(CartKey, JSON.stringify(data));
}

export function setTransactionId(data) {
  return localStorage.setItem(TransactionKey, data);
}


export function getOrder() {
  if (localStorage.getItem(OrderKey))
    return JSON.parse(localStorage.getItem(OrderKey));
  return [];
}

export function getCart() {
  if (localStorage.getItem(CartKey))
    return JSON.parse(localStorage.getItem(CartKey));
  return [];
}

export function getTransactionId() {
  return localStorage.getItem(TransactionKey);
}

export function removeOrder() {
  return localStorage.removeItem(OrderKey);
}

export function removeCart() {
  return localStorage.removeItem(CartKey);
}

export function removeTransaction() {
  return localStorage.removeItem(TransactionKey);
}